import styled, { css } from 'styled-components/macro';

export const PhoneWrapper = styled.div<{ isDisabled: boolean }>`
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
  cursor: pointer;

  ${({ theme }) => css`
    border-radius: ${theme.radiuses.xs};
  `}

  ${({ theme, isDisabled }) =>
    isDisabled &&
    css`
      background-color: ${theme.colors.gray['100']};
      cursor: not-allowed;
    `}

  .svg-viewer {
    width: 16px;
    height: 16px;
  }
`;
